import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EmployeeAreaList } from "../../Types/EmployeeInterface";
import { getContactAreaList } from "../../Thunks/contactThunks";

interface ContactAreaSliceState {
    loader: boolean; // for refres pages and inital loadings
    areaList: EmployeeAreaList [];
    errorDisplay: string | null;
}

// set inital valus
const initialState : ContactAreaSliceState = {
    loader: false,
    areaList: [],
    errorDisplay: '',

}

// set state valu for api response
const contactAreaSlice = createSlice ({
    name: 'contactAreaSlice',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getContactAreaList.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getContactAreaList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getContactAreaList.fulfilled, (state, action: PayloadAction<EmployeeAreaList[]>) => {
                    state.loader = false;
                    state.areaList = action.payload;
                  })
    }
})

export const {} = contactAreaSlice.actions
export default contactAreaSlice.reducer
